import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Line,
  Label
} from 'recharts';
import ChartConfig, { tooltipStyle } from 'Constants/chart-config';

import {  
  mskVisualisationDetails
} from 'Actions';

class latmuscleChartComponent extends Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  render() {

    const { visualisationdetails, loading} = this.props;
    let latmusclelist= visualisationdetails.latmuscle; 
    
    const data=latmusclelist.map((assmntval) => {  
          return {
              
              name: assmntval.assessment,
              right: assmntval.right,
              left:  assmntval.left,
              combined: assmntval.combined
          }
    }); 
    return (
      
      <ResponsiveContainer width={this.props.data} height={400}>         
        <BarChart data={data}>
          <XAxis dataKey="name" stroke={ChartConfig.axesColor} />
          <YAxis orientation="left" stroke={ChartConfig.axesColor} domain={[0, 'dataMax + 20']} />
          <YAxis yAxisId="comb" dataKey="combined" orientation="right" stroke={ChartConfig.axesColor} />
          <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
          <Tooltip wrapperStyle={tooltipStyle} cursor={false} />
          <Legend />
          <Bar dataKey="right" name="Right Lats Muscle Length" fill={ChartConfig.color.leftshIR} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="left" name="Left Lats Muscle Length" fill={ChartConfig.color.rightshER} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="combined" yAxisId="comb" name="Combined Elevation Test"  fill={ChartConfig.color.leftshER} label={{ position: "top" }} barSize={20}/>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

const mapStateToProps = ({ mskvisualisation }) => {
  const { visualisationdetails, loading } = mskvisualisation;
return { visualisationdetails, loading };
}

export default connect(mapStateToProps, {
  mskVisualisationDetails
})(latmuscleChartComponent); 